import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import ClientSideConfigSelector from '../../../recoil/cashout/ClientSideConfigSelector';

export default function CashoutEducate() {
  const { t } = useTranslation(null, { useSuspense: false });

  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        supportMail,
        supportLink,
        paymentProvider,
        providers: {
          [paymentProvider]: {
            display: providerDisplay,
          },
        },
      } = {},
    } = {},
  } = config || {};

  const isPaypal = paymentProvider === 'paypal';
  const isTipalti = paymentProvider === 'tipalti';
  const isWire = paymentProvider === 'wire';

  return (
    <div className="member-diamonds-educate">

      {/* How can I receive my Cash Reward? */}
      <br />
      <p className="educate-diamonds-faq-question">
        {t('educate_how_do_i_get_my_cash_')}
      </p>
      <br />
      <p>
        {isWire
          ? t('educate_you_can_cash_out_funds_via_provider_short', { provider: providerDisplay })
          : t('educate_you_can_cash_out_funds_via_provider', { provider: providerDisplay })}
      </p>

      {isTipalti && (
        <p>
            {t('educate_tipalti_setup_is_handled_for_you')}
        </p>
      )}

      {/* Are there any fees to claim my Cash Reward? */}
      {supportLink && (
        <>
          <br />
          <p className="educate-diamonds-faq-question">
            {t('educate_do_i_need_to_pay_any_fees_to_cash_out_')}
          </p>
          <br />
          <p>
            <span
              dangerouslySetInnerHTML={{
                __html: t('educate___app___will_not_charge_you_any_withdrawal_fees__however__there_still_may_be_transaction_fees_from_provider__you_can_visit_provider', {
                  cashoutRewardSupportLink: supportLink,
                }),
              }}
            />
          </p>
        </>
      )}

      {/* How often can I claim my Cash Reward? */}
      <br />
      <p className="educate-diamonds-faq-question">
        {t('educate_are_there_any_restrictions_on_the_number_of_times_i_can_cash_out_')}
      </p>
      <br />
      <p>
        {t('educate_you_may_cash_out_once_per_calendar_day__any_attempt_to_cash_out_more_than_once_per_day_will_be_rejected_')}
      </p>

      {/* How long does it take to receive my Cash Reward? */}
      <br />
      <p className="educate-diamonds-faq-question">
        {t('educate_how_long_will_it_take_to_receive_my_cash_')}
      </p>
      <br />
      <p>
        {t('educate_for_security_reasons__each_cash_out_request_will_be_manually_reviewed_by_the___app___staff_within___days_of_receipt__once_the_request_is_approved__the_time_to_receive_funds_from_provider_usually_takes_between_____business_days_')}
      </p>

      {/* What do the payment request statuses in my transaction history mean? */}
      <br />
      <p className="educate-diamonds-faq-question">
        {t('educate_the_following_statuses_may_appear_next_to_your_request_')}
      </p>
      <br />
      <p>
        <span className="diamond-history-transaction-status transaction-state-pending">
          {t('educate_pending')}
          {': '}
        </span>
        {t('educate_your_cash_reward_request_has_been_received_and_will_be_manually_reviewed_by_our_staff_')}
      </p>
      <p>
        <span className="diamond-history-transaction-status transaction-state-submitted">
          {t('educate_submitted')}
          {': '}
        </span>
        {t('educate_your_cash_out_request_has_been_approved_and_your_payment_has_been_submitted_to_provider', { provider: providerDisplay })}
      </p>
      <p>
        <span className="diamond-history-transaction-status transaction-state-complete">
          {t('educate_complete')}
          {': '}
        </span>
        {t('educate_your_cash_has_been_delivered_')}
      </p>
      <p>
        <span className="diamond-history-transaction-status transaction-state-onhold">
          {t('educate_onhold')}
          {': '}
        </span>
        {t('educate_onhold_description')}
      </p>
      <p>
        <span className="diamond-history-transaction-status transaction-state-failed">
          {t('educate_cancelled_')}
          {': '}
        </span>
        {t('educate_we_have_cancelled_your_cash_out_order__please_contact_support_for_assistance_')}
      </p>
      <p>
        <span className="diamond-history-transaction-status transaction-state-returned">
          {t('educate_returned')}
          {': '}
        </span>
        {t('educate_returned_description')}
      </p>

      {/* To see more details about your request, simply tap on its status. */}
      <br />
      <p className="educate-diamonds-faq-question">
        {t('educate_tapping_on_the_status_will_bring_up_more_information_about_your_request_')}
      </p>

      <br />
      <p>
        {t('educate_order__the___app___id_that_will_appear_on_your_provider_payment_notes', { provider: providerDisplay })}
      </p>
      {isPaypal ? (
        <p>
          {t('educate_external_order____provider_transaction_id')}
        </p>
      ) : null}
      <h4>
        {t('educate_contact_us')}
      </h4>
      <p>
        {t('educate_if_you_have_any_questions_or_concerns__please_contact_us_at_support_themeetgroup_com_', { support: supportMail })}
      </p>
      <div className="text-center">
        <a href={`mailto:${supportMail}?subject=Cash Reward Support Request`} className="btn btn-success">{t('educate_contact_support')}</a>
      </div>
    </div>
  );
}
